/* =========================================================
   RAVEN STORE — theme behaviour
   ========================================================= */
(function () {
  'use strict';

  var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(path) { return (routes.replace(/\/$/, '')) + path; }

  var state = { cartOpen: false, count: 0, lastFocus: null };

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function drawer() { return $('#rv-cart-drawer'); }

  /* ---------- header basket ---------- */
  function bumpBag() {
    $$('.rv-bag').forEach(function (bag) {
      bag.classList.remove('is-bumping');
      void bag.offsetWidth; // restart the keyframes
      bag.classList.add('is-bumping');
      setTimeout(function () { bag.classList.remove('is-bumping'); }, 620);
    });
  }

  function paintCount(n) {
    var count = Number(n) || 0;
    $$('[data-cart-count-target]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
    $$('.rv-bag').forEach(function (bag) {
      bag.setAttribute('aria-label', count > 0 ? 'Hap shportën (' + count + ')' : 'Hap shportën');
    });
  }

  // Reads the authoritative count off the freshly rendered drawer and
  // syncs the header. Bumps the basket only when the count went UP.
  function syncCount(silent) {
    var d = drawer();
    var count = d ? (Number(d.getAttribute('data-cart-count')) || 0) : 0;
    paintCount(count);
    if (!silent && count > state.count) bumpBag();
    state.count = count;
  }

  /* ---------- open / close ---------- */
  function applyOpenState() {
    var d = drawer();
    if (!d) return;
    d.classList.toggle('is-open', state.cartOpen);
    d.setAttribute('aria-hidden', state.cartOpen ? 'false' : 'true');
  }

  function lockScroll(on) {
    if (on) {
      var sbw = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  function openCart() {
    var d = drawer();
    if (!d || state.cartOpen) return;
    state.lastFocus = document.activeElement;
    // Force a style recalc so the panel's translateX(100%) is committed
    // as a starting frame — without this the transition never runs.
    void d.offsetWidth;
    state.cartOpen = true;
    applyOpenState();
    lockScroll(true);
    var close = $('.rv-drawer__close', d);
    if (close) setTimeout(function () { close.focus({ preventScroll: true }); }, 80);
  }

  function closeCart() {
    if (!state.cartOpen) return;
    state.cartOpen = false;
    applyOpenState();
    lockScroll(false);
    if (state.lastFocus && document.contains(state.lastFocus)) {
      state.lastFocus.focus({ preventScroll: true });
    }
    state.lastFocus = null;
  }

  /* ---------- render cart drawer from Section Rendering API ----------
     We patch ONLY [data-cart-content] and keep the drawer shell alive.
     Replacing the whole section would destroy the panel element and kill
     every CSS transition on it. */
  function swapDrawer(html) {
    var live = drawer();
    if (!live || typeof html !== 'string') return;

    var fresh = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('#rv-cart-drawer');
    if (!fresh) return;

    var liveContent = $('[data-cart-content]', live);
    var freshContent = $('[data-cart-content]', fresh);
    if (liveContent && freshContent) liveContent.replaceWith(freshContent);

    live.setAttribute('data-cart-count', fresh.getAttribute('data-cart-count') || '0');
    syncCount();
  }

  function fetchDrawer() {
    return fetch(url('/?sections=cart-drawer'))
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data['cart-drawer']) swapDrawer(data['cart-drawer']); });
  }

  /* ---------- cart mutations ---------- */
  function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = '···'; btn.disabled = true; }
    fetch(url('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }], sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { // error (e.g. sold out)
          flash(data.description || 'Nuk u shtua dot në shportë');
        } else {
          if (data.sections && data.sections['cart-drawer']) swapDrawer(data.sections['cart-drawer']);
          openCart();
        }
      })
      .catch(function () { flash('Diçka shkoi keq'); })
      .finally(function () {
        if (btn) { btn.textContent = btn.dataset.label || 'Shto në Shportë'; btn.disabled = false; }
      });
  }

  function changeLine(line, quantity) {
    var d = drawer();
    if (d) d.classList.add('is-busy');
    fetch(url('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections && data.sections['cart-drawer']) swapDrawer(data.sections['cart-drawer']);
      })
      .catch(function () { flash('Diçka shkoi keq'); })
      .finally(function () { if (d) d.classList.remove('is-busy'); });
  }

  function flash(msg) {
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:var(--rv-crimson);color:#fff;padding:.8rem 1.2rem;border-radius:999px;z-index:200;font-weight:700;letter-spacing:.04em;text-transform:uppercase;font-size:.8rem;box-shadow:0 12px 30px -8px rgba(225,29,42,.7)';
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 2600);
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var add = t.closest('[data-add-variant]');
    if (add) {
      e.preventDefault();
      addToCart(add.getAttribute('data-add-variant'), 1, add);
      return;
    }

    var inc = t.closest('[data-line-inc]');
    if (inc) { changeLine(inc.getAttribute('data-line-inc'), inc.getAttribute('data-qty')); return; }
    var dec = t.closest('[data-line-dec]');
    if (dec) { changeLine(dec.getAttribute('data-line-dec'), dec.getAttribute('data-qty')); return; }
    var rem = t.closest('[data-line-remove]');
    if (rem) { changeLine(rem.getAttribute('data-line-remove'), 0); return; }

    var burger = t.closest('[data-menu-toggle]');
    if (burger) {
      var mnav = $('#rv-mnav');
      if (mnav) mnav.classList.toggle('is-open');
      return;
    }
  });

  /* ---------- keyboard: Esc to close, Tab trapped inside the drawer ---------- */
  document.addEventListener('keydown', function (e) {
    if (!state.cartOpen) return;

    if (e.key === 'Escape') { closeCart(); return; }
    if (e.key !== 'Tab') return;

    var d = drawer();
    if (!d) return;
    var focusables = $$('a[href], button:not([disabled]), input, select, textarea', d)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- PDP: variant picker ---------- */
  function initProductForm(form) {
    var dataEl = $('[data-variant-json]', form);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var priceEl = $('[data-pdp-price]', form);
    var compareEl = $('[data-pdp-compare]', form);
    var addBtn = $('[data-pdp-add]', form);
    var idField = $('[data-variant-id-field]', form);
    var moneyFormat = dataEl.getAttribute('data-money-format') || '${{amount}}';

    function fmtMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount)
                        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
    }

    function currentOptions() {
      return Array.prototype.map.call(form.querySelectorAll('[data-option-index]'), function (group) {
        var checked = group.querySelector('input:checked') || group.querySelector('select');
        return checked ? checked.value : null;
      });
    }

    function update() {
      var opts = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!match) return;
      if (idField) idField.value = match.id;
      if (addBtn) addBtn.setAttribute('data-add-variant', match.id);
      if (priceEl) priceEl.textContent = fmtMoney(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = fmtMoney(match.compare_at_price);
          compareEl.style.display = '';
        } else { compareEl.style.display = 'none'; }
      }
      if (addBtn) {
        if (match.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label-add') || 'Shto në Shportë'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sosur'; }
      }
    }

    form.addEventListener('change', update);
    update();
  }

  /* ---------- init ---------- */
  function setHeaderOffset() {
    var h = $('.rv-header');
    if (h) document.documentElement.style.setProperty('--rv-mnav-top', h.offsetHeight + 'px');
  }

  function init() {
    syncCount(true); // paint the badge on load, no bump
    applyOpenState();
    setHeaderOffset();
    window.addEventListener('resize', setHeaderOffset);
    $$('[data-product-form]').forEach(initProductForm);

    // cart changed in another tab / back-forward cache
    window.addEventListener('pageshow', function (e) { if (e.persisted) fetchDrawer(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
